import { User, Permission } from '../types';

// Define permission sets for different roles
const SUPER_ADMIN_PERMISSIONS: Permission[] = [
  {
    resource: 'clients',
    actions: ['create', 'read', 'update', 'delete'],
    scope: 'all'
  },
  {
    resource: 'banner_sets',
    actions: ['create', 'read', 'update', 'delete', 'export'],
    scope: 'all'
  },
  {
    resource: 'banners',
    actions: ['create', 'read', 'update', 'delete', 'export'],
    scope: 'all'
  },
  {
    resource: 'users',
    actions: ['create', 'read', 'update', 'delete'],
    scope: 'all'
  },
  {
    resource: 'settings',
    actions: ['read', 'update'],
    scope: 'all'
  }
];

const ADMIN_PERMISSIONS: Permission[] = [
  {
    resource: 'clients',
    actions: ['create', 'read', 'update'],
    scope: 'all'
  },
  {
    resource: 'banner_sets',
    actions: ['create', 'read', 'update', 'delete', 'export'],
    scope: 'all'
  },
  {
    resource: 'banners',
    actions: ['create', 'read', 'update', 'delete', 'export'],
    scope: 'all'
  },
  {
    resource: 'users',
    actions: ['read', 'update'],
    scope: 'assigned'
  }
];

const CLIENT_PERMISSIONS: Permission[] = [
  {
    resource: 'banner_sets',
    actions: ['create', 'read', 'update', 'export'],
    scope: 'own'
  },
  {
    resource: 'banners',
    actions: ['create', 'read', 'update', 'export'],
    scope: 'own'
  }
];

const VIEWER_PERMISSIONS: Permission[] = [
  {
    resource: 'banner_sets',
    actions: ['read'],
    scope: 'own'
  },
  {
    resource: 'banners',
    actions: ['read'],
    scope: 'own'
  }
];

export const SAMPLE_USERS: User[] = [
  {
    id: 'user-super-admin',
    email: 'admin@dealercentives.com',
    name: 'System Administrator',
    role: 'super_admin',
    permissions: SUPER_ADMIN_PERMISSIONS,
    isActive: true,
    createdAt: new Date('2024-01-01'),
    lastLogin: new Date(),
    avatar: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop'
  },
  {
    id: 'user-admin-1',
    email: 'manager@dealercentives.com',
    name: 'Marketing Manager',
    role: 'admin',
    permissions: ADMIN_PERMISSIONS,
    isActive: true,
    createdAt: new Date('2024-01-15'),
    lastLogin: new Date('2024-12-10'),
    avatar: 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop'
  },
  {
    id: 'user-client-1',
    email: 'marketing@invergrove.honda.com',
    name: 'Sarah Johnson',
    role: 'client',
    permissions: CLIENT_PERMISSIONS,
    clientId: 'client-1',
    isActive: true,
    createdAt: new Date('2024-02-01'),
    lastLogin: new Date('2024-12-11'),
    avatar: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop'
  },
  {
    id: 'user-client-2',
    email: 'ads@metrohonda.com',
    name: 'Mike Chen',
    role: 'client',
    permissions: CLIENT_PERMISSIONS,
    clientId: 'client-2',
    isActive: true,
    createdAt: new Date('2024-02-15'),
    lastLogin: new Date('2024-12-09'),
    avatar: 'https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop'
  },
  {
    id: 'user-client-3',
    email: 'marketing@suburbanhonda.com',
    name: 'Lisa Rodriguez',
    role: 'client',
    permissions: CLIENT_PERMISSIONS,
    clientId: 'client-4',
    isActive: true,
    createdAt: new Date('2024-03-01'),
    lastLogin: new Date('2024-12-08'),
    avatar: 'https://images.pexels.com/photos/1181519/pexels-photo-1181519.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop'
  },
  {
    id: 'user-viewer-1',
    email: 'viewer@downtownhonda.com',
    name: 'Tom Wilson',
    role: 'viewer',
    permissions: VIEWER_PERMISSIONS,
    clientId: 'client-3',
    isActive: true,
    createdAt: new Date('2024-03-15'),
    lastLogin: new Date('2024-11-25'),
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=150&h=150&fit=crop'
  }
];